// frontend/src/services/authService.js
import api from '../utils/api';

const authService = {
  // ── Auth ─────────────────────────────────────────────────────────
  login: (username, password) =>
    api.post('/auth/login/', { username, password }).then(r => r.data),

  refreshToken: (refresh) =>
    api.post('/auth/refresh/', { refresh }).then(r => r.data),

  getMe: () =>
    api.get('/auth/me/').then(r => r.data),

  // ── Admin CRUD (superadmin only) ─────────────────────────────────
  /** Returns list of all admin users */
  getUsers: () =>
    api.get('/auth/users/').then(r => r.data.results || r.data),

  /** Create a new admin user */
  register: (userData) =>
    api.post('/auth/users/', userData).then(r => r.data),

  /** Partial-update an existing user by ID */
  updateUser: (id, data) =>
    api.patch(`/auth/users/${id}/`, data).then(r => r.data),

  /** Delete a user by ID */
  deleteUser: (id) =>
    api.delete(`/auth/users/${id}/`),
};

export default authService;